
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import apiUrl from "../../environment/Api";
import "../../assets/css/Addstudent.css";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";

const steps = [
  "Step 1: Personal Details",
  "Step 2: Address Details",
  "Step 3: EMI Details",
  "Step 4: Confirmation",
];
function RegistrationUpdate() {
  const [responseDatas, setResponseDatas] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [responseOldData, setResponseOldData] = useState([]);
  const [responsepayment, setResponsepayment] = useState([]);
  const [responsepurpose, setResponsepurpose] = useState([]);
  const [responsesource, setResponsesource] = useState([]);

  const [addData, setAddData] = useState({});

  const [branch, setbranch] = useState([]);
  const [fees, setfees] = useState([]);
  const navigate = useNavigate();
  const handlecancel = () => {
    navigate("/Studyingstudents");
  };

  const { id } = useParams();
  const [Coursename, setCourse] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);

  const [imagePreview, setImagePreview] = useState(null);

  const [imagePreviewuploade, setImagePreviewuplaod] = useState(null);

  console.log("id is there" + id);
  const [courseData, getCourseData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await axios.get(apiUrl + `/student/${id}`);
      const responsecourse = await axios.get(apiUrl + `/course`);
      const responsepayments = await axios.get(apiUrl + "/paytype");
      const responsepurpose = await axios.get(apiUrl + "/enquiry_purpose");
      const responsesources = await axios.get(apiUrl + "/source_type");
      console.log("Response from studingstudent idss:", response.data);
      if (responsecourse.status === 200) {
        console.log(
          "Preferred Course Lead:",
          response.data[0]?.Prefered_course_lead
        );
        console.log("All Courses:", responsecourse.data);

        // Extract the preferred course name
        const preferredCourse = response.data[0]?.Prefered_course_lead;

        // Ensure the preferred course name exists before filtering
        if (preferredCourse) {
          // Filter courses based on the course name
          const filteredCourses = responsecourse.data.filter(
            (course) => course.course_name === preferredCourse
          );

          console.log("Filtered Courses:", filteredCourses);
          setFilteredData(filteredCourses);
          // If you need to update state, uncomment this:
          // setCourse(filteredCourses);
        } else {
          console.log("No preferred course found.");
        }
      }

      if (response.data.length > 0) {
        const idProofUrl = `${apiUrl}/uploads/${response.data[0].id_proof}`;
        setImagePreview(idProofUrl);
      }
      if (response.data.length > 0) {
        const photouploadUrl = `${apiUrl}/uploads/${response.data[0].photo_upload}`;
        setImagePreviewuplaod(photouploadUrl);
      }

      console.log("Response from server:555", response.data[0]?.category);
      setfees(response);
      setResponsepayment(responsepayments.data);
      getCourseData(responsecourse.data);
      setResponsepurpose(responsepurpose.data);
      setResponsesource(responsesources.data);
      setResponseOldData(response);

      setCourse(response.data[0]?.Prefered_course_lead);
      const data = responsecourse.data;
      setAddData(response.data);
      console.log("Response from server:1212", response.data);
      console.log("Response from server:", response.data[0]?.category);
      console.log("Response from server:", response.data[0]?.category);
      console.log("Response from server:12", Coursename);

      if (response && response.data) {
        const data = response.data;
        const filteredData = data.filter((item) => item.status !== "Converted");
      }
      if (response.data.length > 0) {
        const studentData = response.data[0];
        setAddData([studentData]); // Wrap in array to maintain your structure

        // Initialize datelist with properly formatted dates
        if (studentData.datelist) {
          const formattedDates = studentData.datelist.map((date) =>
            formatDateForInput(date)
          );
          setdatelist(formattedDates);
        }

        // Initialize emilist
        if (studentData.emilist) {
          setemilist(studentData.emilist);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  useEffect(() => {
    fetchDatas();
    fetchDatased();

    const filteredCourses = courseData.filter(
      (course) => course.course_name === Coursename
    );

    // Update `filteredData` state
    setFilteredData(filteredCourses);
  }, []);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  console.log("data is there responseOldData", responseOldData);
  console.log("llolllll", addData);

  const handlesubmit = async (e) => {
    e.preventDefault();

    const validEmilist = (addData[0]?.emilist || [])
      .slice(0, addData[0]?.student_emi || 0)
      .map((amount) => parseFloat(amount) || 0);

    const formData = new FormData();
    formData.append("admission_date", addData[0]?.admission_date);
    formData.append("qualification", addData[0]?.qualification);
    formData.append("duraction", filteredData[0]?.duration);
    formData.append("batch_timings", addData[0]?.batch_timings);
    formData.append("fees", filteredData[0]?.fees);
    formData.append("discount", filteredData[0]?.discount);
    formData.append("student_type", addData[0]?.student_type);
    formData.append("payment_type", addData[0]?.payment_type);
    formData.append("roll_no", addData[0]?.roll_no);
    // formData.append("leads_id", addData[0]?.leads_id[0]?._id);
    formData.append("father_name", addData[0]?.father_name);
    formData.append("current_address", addData[0]?.current_address);
    formData.append("permanent_address", addData[0]?.permanent_address);

    formData.append("date_of_birth", addData[0]?.date_of_birth);
    formData.append("trainer", addData[0]?.trainer);
    formData.append("course_id", addData[0]?.course_id);
    formData.append("register_no", addData[0]?.register_no);
    formData.append("placement", addData[0]?.placement);
    formData.append("branch_lead", addData[0]?.branch_lead);
    formData.append("student_name_lead", addData[0]?.student_name_lead);
    formData.append("mobile_no_lead", addData[0]?.mobile_no_lead);
    formData.append("email_lead", addData[0]?.email_lead);
    formData.append("Prefered_course_lead", Coursename);
    formData.append("purpose_enquiry_lead", addData[0]?.purpose_enquiry_lead);
    formData.append("Enquiry_date_lead", addData[0]?.Enquiry_date_lead);
    formData.append("Source_type_lead", addData[0]?.Source_type_lead);
    formData.append("contact_type_lead", addData[0]?.contact_type_lead);
    formData.append("assign_staff_lead", addData[0]?.assign_staff_lead);
    formData.append(
      "referal_candidate_name_lead",
      addData[0]?.referal_candidate_name_lead
    );
    formData.append(
      "referal_candidate_lead",
      addData[0]?.referal_candidate_lead
    );
    formData.append("followups_time_lead", addData[0]?.followups_time_lead);
    formData.append("followups_date_lead", addData[0]?.followups_date_lead);
    formData.append("status_time_lead", addData[0]?.status_time_lead);
    formData.append("followups_status_lead", addData[0]?.followups_status_lead);
    formData.append("followups_notes_lead", addData[0]?.followups_notes_lead);
    formData.append("interest_lead", addData[0]?.interest_lead);
    formData.append("student_emi", addData[0]?.student_emi);

    formData.append("datelist", JSON.stringify(datelist));
    // formData.append("emilist", JSON.stringify(emilist));

    formData.append("emilist", JSON.stringify(validEmilist));
    if (addData[0]?.photo_upload)
      formData.append("photo_upload", addData[0]?.photo_upload);
    if (addData[0]?.id_proof) formData.append("id_proof", addData[0]?.id_proof);

    const leadsdata = {
      branch_id: addData[0]?.branch_id,
      student_name: addData[0]?.student_name,
      Source_type: addData[0]?.Source_type,
      assign_staff: addData[0]?.assign_staff,
      mobile_no: addData[0]?.mobile_no,
      email: addData[0]?.email,
      Enquiry_date: addData[0]?.Enquiry_date,
      Prefered_course: addData[0]?.Prefered_course,
      followups_status: "converted",
    };

    console.log("formdata", leadsdata);

    try {
      setLoading(true);
      console.log("the registration updatessssssssssssssssss ", formData);
      const response = await axios.put(`${apiUrl}/student/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Updated Successfully!");

      setAddData({
        admission_date: "",
        qualification: "",
        duraction: "",
        batch_timings: "",
        fees: "",
        discount: "",
        student_type: "",
        father_name: "",
        current_address: "",
        permanent_address: "",
        payment_type: "",
        date_of_birth: "",
        roll_no: "",
        photo_upload: null,
        id_proof: null,
        trainer: "",
        course_id: "",
        student_emi: "",
      });
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
      navigate("/Studyingstudents");
    } catch (error) {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      console.error("Error updating data:", error.message);
    }
  };

  const fetchDatas = async () => {
    try {
      const response = await axios.get(apiUrl + "/leads");

      if (response && response.data) {
        const data = response.data;

        setResponseDatas(data);
        console.log("Response from servers63s3s:", data);
      } else {
        console.error("No data received from server.");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value;
    console.log("the select status", selectedStatus);
    setAddData({ ...addData, status: selectedStatus });

    if (selectedStatus === "Callback") {
      setShowCallbackDate(true);
    } else if (selectedStatus === "Converted") {
      setShowCallbackDate(true);
    } else {
      setShowCallbackDate(false);
      setAddData((prevData) => ({
        ...prevData,
        callback_date: "",
        converted_date: "",
      }));
    }
  };

  const [studentId, setSutudentId] = useState([]);
  const [stafftId, setStaffId] = useState([]);
  const fetchDatased = async () => {
    try {
      const response = await axios.get(apiUrl + "/Branch");
      const responsestudent = await axios.get(apiUrl + "/student");
      const responsestaff = await axios.get(apiUrl + "/staff");
      console.log("Response from server:", response.data);
      setbranch(response.data);
      setSutudentId(responsestudent.data);
      setStaffId(responsestaff.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const [showCallbackDate, setShowCallbackDate] = useState(false);

  const [referaltype, setreferaltype] = useState("");

  const handlereferal = (e) => {
    console.log(e.target.value);

    setreferaltype(e.target.value);
  };

  const [activeStep, setActiveStep] = useState(0);

  const [datelist, setdatelist] = useState([]);
  const [emilist, setemilist] = useState([]);
  {
    console.log("the emlist", emilist);
  }

  // Function to format the date for the input field (YYYY-MM-DD)

  const handleemi_amountchange = (e, index) => {
    const value = e.target.value;

    // Create a copy of the current EMI list
    const updatedEMIList = [...emilist];

    // Handle empty input
    if (value === "") {
      updatedEMIList[index] = "";
      setemilist(updatedEMIList);

      // Also update addData if needed
      const newAddData = [...addData];
      newAddData[0].emilist = updatedEMIList;
      setAddData(newAddData);
      return;
    }

    // Parse the input value
    const numericValue = parseFloat(value);

    // Only update if it's a valid number and positive
    if (!isNaN(numericValue) && numericValue >= 0) {
      updatedEMIList[index] = numericValue;
      setemilist(updatedEMIList);

      // Also update addData to keep everything in sync
      const newAddData = [...addData];
      newAddData[0].emilist = updatedEMIList;
      setAddData(newAddData);

      // Optional: Recalculate remaining EMIs to maintain total fees
      if (addData[0]?.fees) {
        const totalFees = parseFloat(addData[0].fees);
        const currentTotal = updatedEMIList.reduce(
          (sum, emi) => sum + (isNaN(emi) ? 0 : emi),
          0
        );

        // If current total exceeds fees, show warning
        if (currentTotal > totalFees) {
          console.warn("Total EMIs exceed course fees!");
        }
      }
    }
  };

  // useEffect(() => {
  //   if (addData[0]?.payment_type === "emi" && addData[0]?.student_emi) {
  //     const numEMIs = parseInt(addData[0].student_emi);
  //     if (numEMIs > 0) {
  //       const monthlyEMI = parseFloat((fees / numEMIs).toFixed(2));
  //       setemilist(Array(numEMIs).fill(monthlyEMI));

  //       // Generate dates if not already set
  //       if (datelist.length !== numEMIs) {
  //         const emiDates = generateEMIDates(numEMIs);
  //         setdatelist(emiDates);
  //       }
  //     }
  //   }
  // }, [addData[0]?.student_emi, fees]);

  // useEffect(() => {
  //   if (addData[0]?.payment_type === "emi" && addData[0]?.student_emi) {
  //     const numEMIs = parseInt(addData[0].student_emi);
  //     if (numEMIs > 0) {
  //       // Format existing dates or generate new ones
  //       const emiDates = addData[0]?.datelist?.length
  //         ? addData[0].datelist.map((date) => formatDateForInput(date))
  //         : generateEMIDates(numEMIs);

  //       setdatelist(emiDates);

  //       const monthlyEMI = fees / numEMIs;
  //       const emiAmounts = addData[0]?.emilist?.length
  //         ? [...addData[0].emilist]
  //         : Array(numEMIs).fill(monthlyEMI);

  //       setemilist(emiAmounts);
  //     }
  //   }
  // }, [addData[0]?.student_emi, fees]);

  useEffect(() => {
    if (addData[0]?.datelist && addData[0].datelist.length > 0) {
      const formattedDates = addData[0].datelist.map((date) =>
        formatDateForInput(date)
      );
      setdatelist(formattedDates);
    }
  }, [addData]);

  // const formatDateForInput = (dateString) => {
  //   if (!dateString) return "";
  //   const date = new Date(dateString);
  //   return date.toISOString().split("T")[0];
  // };

  // const formatDateForInput = (dateString) => {
  //   if (!dateString) return "";

  //   // Handle both ISO strings (with timezone) and simple date strings
  //   const date = new Date(dateString);

  //   // Prevent invalid dates
  //   if (isNaN(date.getTime())) return "";

  //   const year = date.getFullYear();
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const day = String(date.getDate()).padStart(2, "0");

  //   return `${year}-${month}-${day}`;
  // };

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";

    try {
      // Handle both ISO strings and simple date strings
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "";

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    } catch (e) {
      console.error("Date formatting error:", e);
      return "";
    }
  };

  // Generate EMI dates (monthly intervals)
  const generateEMIDates = (numEMIs, startDate = new Date()) => {
    const dates = [];
    for (let i = 0; i < numEMIs; i++) {
      const newDate = new Date(startDate);
      newDate.setMonth(newDate.getMonth() + i);
      dates.push(newDate.toISOString().split("T")[0]);
    }
    return dates;
  };

  // const handleemi_datechange = (e, index) => {
  //   const updatedDates = [...datelist];
  //   updatedDates[index] = e.target.value;
  //   setdatelist(updatedDates);

  //   // Update addData
  //   const newAddData = [...addData];
  //   newAddData[0] = {
  //     ...newAddData[0],
  //     datelist: updatedDates.map((date) => new Date(date).toISOString()),
  //   };
  //   setAddData(newAddData);
  // };

  const handleemi_datechange = (e, index) => {
    const updatedDates = [...datelist];
    updatedDates[index] = e.target.value;
    setdatelist(updatedDates);

    // Update addData with properly formatted dates
    const newAddData = [...addData];
    newAddData[0] = {
      ...newAddData[0],
      datelist: updatedDates.map((date) => {
        // If the date is already in YYYY-MM-DD format, convert to ISO string
        if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
          return new Date(date).toISOString();
        }
        return date;
      }),
    };
    setAddData(newAddData);
  };

  // const handleNext = () => {
  //   if (activeStep === 1) {
  //     if (addData[0]?.payment_type !== "emi") {
  //       // Handle non-EMI case (lump-sum payment)
  //       setdatelist([]);
  //       setemilist([]);
  //       setActiveStep((prevStep) => prevStep + 2); // Skip EMI step
  //     } else {
  //       // EMI case: Validate and generate EMI dates/amounts
  //       const numEMIs = parseInt(addData[0]?.student_emi);
  //       if (!numEMIs || numEMIs <= 0) {
  //         alert("Please enter a valid number of EMIs.");
  //         return;
  //       }
  //       const emiDates = generateEMIDates(numEMIs);
  //       const monthlyEMI = fees / numEMIs;
  //       const emiAmounts = Array(numEMIs).fill(monthlyEMI);
  //       setdatelist(emiDates);
  //       setemilist(emiAmounts);
  //       setActiveStep((prevStep) => prevStep + 1);
  //     }
  //   } else {
  //     setActiveStep((prevStep) => prevStep + 1);
  //   }
  // };

  // const handleBack = () => {
  //   if (addData.payment_type != "emi") {
  //     setdatelist([]);
  //     setemilist([]);
  //   } else if (
  //     activeStep !== steps.length - 1 &&
  //     addData.payment_type == "emi"
  //   ) {
  //     setdatelist([]);
  //     setemilist([]);
  //   }

  //   if (activeStep === steps.length - 1 && addData.payment_type != "emi") {
  //     setActiveStep((prevActiveStep) => prevActiveStep - 2);
  //   } else {
  //     setActiveStep((prevActiveStep) => prevActiveStep - 1);
  //   }
  // };

  const handleNext = () => {
    if (activeStep === 1 && addData[0]?.payment_type === "emi") {
      // Validate EMI data before proceeding
      if (!addData[0]?.student_emi || addData[0].student_emi <= 0) {
        alert("Please enter a valid number of EMIs.");
        return;
      }

      // Ensure datelist is properly formatted
      const formattedDates = datelist.map((date) =>
        date.includes("T") ? date : new Date(date).toISOString()
      );

      setAddData((prev) => [
        {
          ...prev[0],
          datelist: formattedDates,
          emilist: emilist,
        },
      ]);
    }
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    // Preserve EMI data when going back
    if (activeStep === 2 && addData[0]?.payment_type === "emi") {
      setAddData((prev) => [
        {
          ...prev[0],
          datelist: datelist.map((date) =>
            date.includes("T") ? date : new Date(date).toISOString()
          ),
          emilist: emilist,
        },
      ]);
    }
    setActiveStep((prev) => prev - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  // Helper function to format ISO date to YYYY-MM-DD
  const formatDatefitching = (dateString) => {
    if (!dateString) return "";
    return dateString.split("T")[0]; // This will return only the date part (yyyy-mm-dd)
  };
  // Functi
  //
  // on to handle course fetching
  function handelecoursefetch(e) {
    const selectedCourseId = e.target.value;

    console.log(selectedCourseId, "Selected Course ID");

    // Use find() to get the matching course object
    const selectedCourse = courseData.find(
      (item) => item.course_id == selectedCourseId
    );

    console.log("Selected Course:", selectedCourse.course_name);

    if (selectedCourse) {
      // Update addData state with selected course details
      setAddData((prevData) => ({
        ...prevData,
        0: {
          // Ensure you're updating the correct index in the array
          ...prevData[0],
          Prefered_course: selectedCourse.course_name, // Set the course name
          fees: selectedCourse.fees, // Set the fees
          discount: selectedCourse.discount, // Set the discount
          duraction: selectedCourse.duration,
          course_id: selectedCourse.course_id,
        },
      }));
    } else {
      console.error("Course not found");
    }
  }

  const handleChangereg = (e) => {
    setAddData({ ...addData, register_no: e.target.value });
  };
  //web Cam
  const videoRef = useRef(null);
  const fileInputRef = useRef(null);
  const canvasRef = useRef(null);

  const [image, setImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  // const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (addData.length > 0) {
      const photo = addData[0]?.photo_upload;
      const proof = addData[0]?.id_proof;
      setImage(photo ? `${apiUrl}/api/uploads/${photo}` : null);

      setImageFile(proof ? `${apiUrl}/api/uploads/${proof}` : null);
    }
  }, [addData]);

  const [isWebcamActive, setIsWebcamActive] = useState(false);

  // Open file input dialog
  const openFileUpload = () => {
    setIsWebcamActive(false);
    setImagePreviewuplaod(false);

    fileInputRef.current.click();
  };

  // Handle file input change
  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    setAddData((prevData) => ({
      ...prevData,
      0: {
        ...prevData[0],
        photo_upload: file,
      },
    }));

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImagePreviewuplaod(reader.result); // Display the uploaded image
      };
      reader.readAsDataURL(file);
    }
  };

  // Start webcam stream
  const startWebcam = async () => {
    setIsWebcamActive(true);
    setImagePreviewuplaod(false);

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (err) {
      console.error("Error accessing webcam: ", err);
    }
  };

  const captureImage = () => {
    setImagePreviewuplaod(false);

    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    if (video && canvas) {
      // Set canvas size to match video dimensions
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Get the data URL of the captured image
      const imageUrl = canvas.toDataURL("image/png");
      setImagePreviewuplaod(imageUrl); // Optional: if you want to display the image in the UI

      // Convert the data URL to a Blob
      const byteString = atob(imageUrl.split(",")[1]);
      const mimeString = imageUrl.split(",")[0].split(":")[1].split(";")[0];
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uintArray = new Uint8Array(arrayBuffer);

      for (let i = 0; i < byteString.length; i++) {
        uintArray[i] = byteString.charCodeAt(i);
      }

      const blob = new Blob([uintArray], { type: mimeString });

      // Create a File object from the Blob
      const file = new File([blob], "captured_image.png", {
        type: "image/png",
      });

      // Set the file in your state
      // setAddData({ ...addData, photo_upload: file });
      setAddData((prevData) => ({
        ...prevData,
        0: {
          // Ensure you're updating the correct index in the array
          ...prevData[0],
          photo_upload: file, // Correctly update qualification
        },
      }));

      // Stop the webcam after capturing the image
      stopWebcam();
    }
  };

  // Stop the webcam stream
  const stopWebcam = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop()); // Stop each track
      videoRef.current.srcObject = null;
      setIsWebcamActive(false);
    }
  };
  function handleIdProof(e) {
    const file = e.target.files[0];

    if (file) {
      // setAddData({ ...addData, id_proof: file });
      setAddData((prevData) => ({
        ...prevData,
        0: {
          // Ensure you're updating the correct index in the array
          ...prevData[0],
          id_proof: file, // Correctly update qualification
        },
      }));

      const reader = new FileReader();
      reader.onload = () => {
        setImagePreview(reader.result); // Display the uploaded image as base64
      };
      reader.readAsDataURL(file);
    }
  }

  const handleCourseFetch = (e) => {
    const selectedCourse = e.target.value;

    // Update `addData` state
    setCourse(selectedCourse);
    console.log("Filtered Courses:", courseData);
    // Filter the courses based on the selected category
    const filteredCourses = courseData.filter(
      (course) => course.course_name === selectedCourse
    );

    setFilteredData(filteredCourses);

    console.log("Filtered Courses:filteredCourses", filteredCourses);
  };

  const [isCheck, setIsCheck] = useState(false);

  const handleClickCheckBox = () => {
    setIsCheck(true);
  };

  const [loading, setLoading] = useState(false);

  const handleEmiCountChange = (e) => {
    const rawValue = e.target.value;

    // If input is empty, set empty state but keep validation
    if (rawValue === "") {
      setAddData((prevData) => {
        if (!prevData || !prevData[0]) {
          return [
            {
              student_emi: "",
              emilist: [],
              fees: parseFloat(addData[0]?.fees) || 0,
            },
          ];
        }
        return [
          {
            ...prevData[0],
            student_emi: "",
            emilist: [],
          },
        ];
      });
      return;
    }

    // Process non-empty values
    const emiCount = Math.max(1, parseInt(rawValue) || 1);
    const totalFees = parseFloat(addData[0]?.fees) || 0;

    // Calculate amounts
    let newEmilist = [totalFees]; // Default single payment

    if (emiCount > 1 && totalFees > 0) {
      const baseAmount = parseFloat((totalFees / emiCount).toFixed(2));
      const remainder = parseFloat(
        (totalFees - baseAmount * (emiCount - 1)).toFixed(2)
      );

      newEmilist = Array.from({ length: emiCount }, (_, i) =>
        i === emiCount - 1 ? remainder : baseAmount
      );
    }

    // Update state
    setAddData((prevData) => {
      if (!prevData || !prevData[0]) {
        return [
          {
            student_emi: emiCount,
            emilist: newEmilist,
            fees: totalFees,
          },
        ];
      }

      return [
        {
          ...prevData[0],
          student_emi: emiCount,
          emilist: newEmilist,
        },
      ];
    });
  };
  // Handle change in individual EMI amount
  const handleEmiAmountChange = (e, index) => {
    const newAmount = parseFloat(e.target.value) || 0;

    setAddData((prevData) => {
      const newData = [...prevData];
      const currentEmilist = [...newData[0].emilist];

      // Update the specific EMI amount
      currentEmilist[index] = newAmount;

      // Calculate the remaining amount to distribute
      const totalFees = parseFloat(newData[0].fees);
      const enteredAmount = currentEmilist.reduce(
        (sum, amount) => sum + amount,
        0
      );
      const remainingAmount = totalFees - enteredAmount;

      // If remaining amount is negative, adjust the current EMI
      if (remainingAmount < 0) {
        currentEmilist[index] += remainingAmount;
      }

      newData[0] = {
        ...newData[0],
        emilist: currentEmilist,
      };

      return newData;
    });
  };

  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}
      <div
        className="style"
        style={{ marginTop: "-80px", marginBottom: "30px" }}
      >
        <div className="row mb-3">
          <div className="col-lg-11">
            <Link to="/dashboard" className="text-secondary dashBoard_text">
              <b>Dashboard / </b>
            </Link>
            <Link to="#" className="text-secondary dashBoard_text">
              <b>Entrollment / </b>
            </Link>
            <Link
              to="/Studyingstudents"
              className="text-secondary dashBoard_text"
            >
              <b>Studying Student / </b>
            </Link>
            <Link to="" className="text-danger dashBoard_text">
              <b> Registration Update</b>
            </Link>
          </div>
        </div>
        <div className="insermodal">
          <div>
            <h5>Registration Update</h5>
            <div className="row mt-5 ">
              {activeStep === 0 && (
                <div className="col-lg-12" style={{ marginTop: "-25px" }}>
                  <div className="card  p-4 pb-0">
                    <h4 className="mt-1 mb-3"> Step 1</h4>
                    <div className="form-group">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="floating-label mt-1">
                            <label className="form-label">
                              <b></b>
                            </label>
                            <select
                              className="form-select"
                              placeholder=""
                              value={addData[0]?.branch_lead}
                              onChange={(e) =>
                                setAddData((prevData) => {
                                  const newBranchId = e.target.value; // Get the new branch ID from the select
                                  return {
                                    ...prevData,
                                    0: {
                                      // Ensure you correctly update the first element of addData
                                      ...prevData[0],

                                      ...prevData[0]?.branch_lead, // Spread the previous leads_id object
                                      branch_lead: newBranchId, // Update the branch_id
                                    },
                                  };
                                })
                              }
                              required
                            >
                              <option value="">Select Branch</option>
                              {branch.map((item, index) => (
                                <option key={index} value={item._id}>
                                  {item.branch_name}
                                </option>
                              ))}
                            </select>

                            <label
                              className={addData.branch_lead ? "filled" : ""}
                            ></label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              placeholder=""
                              value={addData[0]?.father_name || ""} // Controlled input for father_name
                              onChange={(e) =>
                                setAddData((prevData) => {
                                  const updatedData = [...prevData];
                                  updatedData[0] = {
                                    ...updatedData[0],
                                    father_name: e.target.value,
                                  };
                                  return updatedData;
                                })
                              }
                            />
                            <label
                              className={
                                addData[0]?.father_name ? "filled" : ""
                              }
                            >
                              Father Name
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              placeholder=""
                              value={addData[0]?.student_name_lead || ""} // Controlled input
                              onChange={(e) =>
                                setAddData((prevData) => ({
                                  ...prevData,
                                  0: {
                                    ...prevData[0],

                                    ...prevData[0]?.student_name_lead,
                                    student_name_lead: e.target.value, // Correctly update student_name
                                  },
                                }))
                              } // Handle onChange event
                              required
                            />
                            {/* Conditionally apply the "filled" class to the label if student_name exists */}
                            <label
                              className={
                                addData[0]?.student_name_lead ? "filled" : ""
                              }
                            >
                              Student Name
                            </label>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              placeholder=""
                              value={addData[0]?.qualification || ""}
                              onChange={(e) =>
                                setAddData((prevData) => ({
                                  ...prevData,
                                  0: {
                                    ...prevData[0],
                                    qualification: e.target.value,
                                  },
                                }))
                              }
                            />
                            <label
                              className={
                                addData[0]?.qualification ? "filled" : ""
                              }
                            >
                              Qualification
                            </label>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="number"
                              maxLength={10}
                              value={addData[0]?.mobile_no_lead}
                              onChange={(e) =>
                                setAddData((prevData) => ({
                                  ...prevData,
                                  0: {
                                    ...prevData[0],

                                    ...prevData[0]?.mobile_no_lead,
                                    mobile_no_lead: e.target.value, // Correctly update student_name
                                  },
                                }))
                              } // Store the file object
                              required
                            />
                            <label
                              className={addData.mobile_no_lead ? "filled" : ""}
                            >
                              Mobile No
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="date"
                              value={formatDatefitching(
                                addData[0]?.date_of_birth || ""
                              )}
                              onChange={(e) =>
                                setAddData((prevData) => ({
                                  ...prevData,
                                  0: {
                                    // Ensure you're updating the correct index in the array
                                    ...prevData[0],
                                    date_of_birth: e.target.value, // Correctly update qualification
                                  },
                                }))
                              } // Store the file object
                              required
                            />
                            <label
                              className={
                                addData[0]?.date_of_birth ? "filled" : ""
                              }
                            >
                              Date of Birth
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="email"
                              value={addData[0]?.email_lead}
                              onChange={(e) =>
                                setAddData((prevData) => ({
                                  ...prevData,
                                  0: {
                                    ...prevData[0],

                                    ...prevData[0]?.email_lead,
                                    email_lead: e.target.value, // Correctly update student_name
                                  },
                                }))
                              } // Store the file object
                              required
                            />
                            <label
                              className={addData.email_lead ? "filled" : ""}
                            >
                              Email
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <select
                              className="form-control"
                              value={addData[0]?.purpose_enquiry_lead || ""}
                              onChange={(e) =>
                                setAddData((prevData) => ({
                                  ...prevData,
                                  0: {
                                    // Ensure you're updating the correct index in the array
                                    ...prevData[0],
                                    purpose_enquiry_lead: e.target.value, // Correctly update qualification
                                  },
                                }))
                              }
                              required
                            >
                              <option value="">Select Enquiry Purpose</option>
                              {responsepurpose.map((item, index) => (
                                <option
                                  key={index}
                                  value={item.enquiry_purpose}
                                >
                                  {item.enquiry_purpose}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div>
                            <p>Upload Image</p>

                            {/* Buttons for selecting file or webcam */}
                            <button
                              onClick={openFileUpload}
                              className="btn border btn-secondary mx-2  "
                              aria-label="Upload from file"
                            >
                              <i className="fa fa-file" /> Upload
                            </button>
                            <button
                              onClick={startWebcam}
                              className="btn border btn-secondary  mx-2  "
                              aria-label="Open webcam"
                            >
                              <i className="fa fa-camera mx-2" />
                              Live
                            </button>

                            {/* Hidden file input for image upload */}
                            <input
                              type="file"
                              ref={fileInputRef}
                              onChange={handleFileUpload}
                              accept="image/*"
                              style={{ display: "none" }}
                            />

                            {/* Video element to show webcam stream */}
                            {isWebcamActive && (
                              <div>
                                <video
                                  ref={videoRef}
                                  autoPlay
                                  width="200"
                                  height="200"
                                />
                                <button
                                  className="mx-2 fs-2 bg-transparent border-0"
                                  onClick={(e) => captureImage(e)}
                                  aria-label="Capture image from webcam"
                                >
                                  <i className="fa-solid fa-computer-mouse"></i>
                                </button>
                              </div>
                            )}

                            {/* Hidden canvas to capture webcam image */}
                            <canvas
                              ref={canvasRef}
                              style={{ display: "none" }}
                            />

                            {/* Display captured or uploaded image */}
                            {imagePreviewuploade && (
                              <div>
                                <p></p>
                                <img
                                  src={imagePreviewuploade}
                                  alt="Uploaded or Captured"
                                  width="200"
                                  height="200"
                                  className="object-fit-cover"
                                />
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="file"
                              onChange={handleIdProof} // Store the file object
                              required
                            />
                            <label className={addData.id_proof ? "filled" : ""}>
                              ID Proof
                            </label>
                            {imagePreview ? (
                              <div>
                                <p></p>
                                <img
                                  src={imagePreview}
                                  alt="ID Proof"
                                  width="200"
                                  height="200"
                                  className="object-fit-cover"
                                />
                              </div>
                            ) : (
                              <p>No ID Proof available</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* ////////////////////////////////////////////////// */}
              {activeStep === 1 && (
                <div className="col-lg-12" style={{ marginTop: "-25px" }}>
                  <div className="card p-2 pb-0">
                    <div className="form-group">
                      <div className="row">
                        <h4 className="mt-2 mb-4"> Step 2</h4>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              placeholder=""
                              value={addData[0]?.permanent_address || ""} // Controlled input for father_name
                              onChange={(e) =>
                                setAddData((prevData) => {
                                  const updatedData = [...prevData];
                                  updatedData[0] = {
                                    ...updatedData[0],
                                    permanent_address: e.target.value,
                                  };
                                  return updatedData;
                                })
                              }
                            />
                            <label
                              className={
                                addData[0]?.permanent_address ? "filled" : ""
                              }
                            >
                              Permanent Address
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              disabled
                              type="text"
                              placeholder=""
                              value={addData[0]?.roll_no}
                              onChange={(e) =>
                                setAddData((prevData) => ({
                                  ...prevData,
                                  0: {
                                    ...prevData[0],
                                    roll_no: e.target.value,
                                  },
                                }))
                              }
                            />
                            <label
                              className={addData[0]?.roll_no ? "filled" : ""}
                            >
                              Roll Number
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              placeholder=""
                              value={addData[0]?.current_address || ""} // Controlled input for father_name
                              onChange={(e) =>
                                setAddData((prevData) => {
                                  const updatedData = [...prevData];
                                  updatedData[0] = {
                                    ...updatedData[0],
                                    current_address: e.target.value,
                                  };
                                  return updatedData;
                                })
                              }
                            />
                            <label
                              className={
                                addData[0]?.current_address ? "filled" : ""
                              }
                            >
                              Current Address
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              disabled
                              placeholder=""
                              value={filteredData[0]?.fees}
                              onChange={(e) =>
                                setAddData({ ...addData, fees: e.target.value })
                              }
                            />
                            <label className={addData.fees ? "filled" : ""}>
                              Fees
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              disabled
                              placeholder=""
                              value={addData[0]?.category}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  category: e.target.value,
                                })
                              }
                            />
                            <label className={addData.category ? "filled" : ""}>
                              Category
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <select
                              disabled
                              className="form-select"
                              value={Coursename}
                              onChange={(e) => handleCourseFetch(e)}
                              required
                            >
                              <option disabled value="">
                                Select Course
                              </option>{" "}
                              {/* Ensure value is empty string for default */}
                              {courseData.map((item, index) => (
                                <option key={index} value={item.course_name}>
                                  {item.course_id}-{item.course_name}
                                </option>
                              ))}
                            </select>
                            <label
                              className={addData[0]?.course_id ? "filled" : ""}
                            >
                              Preferred Course
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              disabled
                              placeholder=""
                              value={filteredData[0]?.discount}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  discount: e.target.value,
                                })
                              }
                            />
                            <label
                              className={
                                addData[0]?.leads_id[0]?.discount
                                  ? "filled"
                                  : ""
                              }
                            >
                              Discount
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="date"
                              value={formatDatefitching(
                                addData[0]?.Enquiry_date_lead
                              )}
                              onChange={(e) =>
                                setAddData((prevData) => ({
                                  ...prevData,
                                  0: {
                                    ...prevData[0],

                                    ...prevData[0]?.Enquiry_date_lead,
                                    Enquiry_date_lead: e.target.value, // Correctly update student_name
                                  },
                                }))
                              }
                              required
                            />
                            <label
                              className={
                                addData[0]?.Enquiry_date_lead ? "filled" : ""
                              }
                            >
                              Enquiry date
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              disabled
                              placeholder=""
                              value={filteredData[0]?.duration}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  duration: e.target.value,
                                })
                              }
                            />
                            <label className={addData.duration ? "filled" : ""}>
                              Duration
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="date"
                              value={formatDatefitching(
                                addData[0]?.admission_date || ""
                              )}
                              onChange={(e) =>
                                setAddData((prevData) => ({
                                  ...prevData,
                                  0: {
                                    // Ensure you're updating the correct index in the array
                                    ...prevData[0],
                                    admission_date: e.target.value, // Correctly update qualification
                                  },
                                }))
                              } // Store the file object
                              required
                            />
                            <label
                              className={
                                addData[0]?.admission_date ? "filled" : ""
                              }
                            >
                              Admission Date
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              placeholder=""
                              value={addData[0]?.batch_timings || ""} // Controlled input for father_name
                              onChange={(e) =>
                                setAddData((prevData) => {
                                  const updatedData = [...prevData];
                                  updatedData[0] = {
                                    ...updatedData[0],
                                    batch_timings: e.target.value,
                                  };
                                  return updatedData;
                                })
                              }
                            />
                            <label
                              className={
                                addData[0]?.batch_timings ? "filled" : ""
                              }
                            >
                              Batch timing
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          {console.log(
                            addData.Source_type_lead,
                            "addData.Source_type ---"
                          )}

                          <select
                            className="form-select"
                            placeholder=""
                            value={addData[0]?.Source_type_lead || ""}
                            onChange={(e) =>
                              setAddData({
                                ...addData,
                                Source_type_lead: e.target.value,
                              })
                            }
                            required
                          >
                            <option value="">Select Source Type </option>
                            {responsesource.map((item, index) => (
                              <option key={index} value={item.source_type}>
                                {item.source_type}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-lg-6">
                          <div className="floating-label">
                            <select
                              className="form-select"
                              value={addData[0]?.payment_type}
                              onChange={(e) =>
                                setAddData((prevData) => ({
                                  ...prevData,
                                  0: {
                                    // Ensure you're updating the correct index in the array
                                    ...prevData[0],
                                    payment_type: e.target.value, // Correctly update qualification
                                  },
                                }))
                              }
                              required
                            >
                              <option value="">Payment Type</option>
                              <option value="Full Payment">Full Payment</option>
                              <option value="emi">EMI</option>
                              {/* {responsepayment.map((item, index) => (
                                <option key={index} value={item.Payment_type}>
                                  {item.Payment_type}
                                </option>
                              ))} */}
                            </select>
                            <label
                              className={
                                addData[0]?.payment_type ? "filled" : ""
                              }
                            ></label>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="floating-label">
                            <select
                              className="form-control"
                              value={addData[0]?.trainer || ""} // Ensure it starts with an empty string if not set
                              onChange={(e) =>
                                setAddData((prevData) => ({
                                  ...prevData,
                                  0: {
                                    // Ensure you're updating the correct index in the array
                                    ...prevData[0],
                                    trainer: e.target.value, // Correctly update qualification
                                  },
                                }))
                              }
                            >
                              <option value="" disabled>
                                Select Trainer
                              </option>{" "}
                              {/* Ensure value is empty for disabled option */}
                              {stafftId.map((data, index) => (
                                <option key={index} value={data.empid}>
                                  {data.name} - {data.empid}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        {addData[0]?.payment_type === "emi" && (
                          <div className="col-lg-6">
                            <div className="floating-label">
                              <input
                                className="form-control"
                                type="text"
                                placeholder=""
                                value={addData[0]?.student_emi}
                                onChange={handleEmiCountChange}
                              />
                              <label
                                className={
                                  addData[0]?.student_emi ? "filled" : ""
                                }
                              >
                                No of EMI
                              </label>
                            </div>
                          </div>
                        )}

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              placeholder=""
                              disabled
                              value={addData[0]?.register_no || ""} // Ensure it starts with an empty string if not set
                              onChange={handleChangereg}
                              required
                            />
                            <label
                              className={addData.register_no ? "filled" : ""}
                            >
                              Registration No
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <label>Placement</label>
                          <br />
                          <label>
                            <input
                              type="radio"
                              name="option"
                              value="Yes" // Set the correct value for "yes"
                              checked={addData[0]?.placement === "Yes"} // Check if the placement is "yes"
                              onChange={(e) =>
                                setAddData((prevData) => ({
                                  ...prevData,
                                  0: {
                                    // Ensure you're updating the correct index in the array
                                    ...prevData[0],
                                    placement: e.target.value, // Correctly update qualification
                                  },
                                }))
                              } // Update placement state
                            />
                            &nbsp; Yes &nbsp;
                          </label>
                          <label>
                            <input
                              type="radio"
                              name="option"
                              value="No" // Set the correct value for "no"
                              checked={addData[0]?.placement === "No"} // Check if the placement is "no"
                              onChange={(e) =>
                                setAddData((prevData) => ({
                                  ...prevData,
                                  0: {
                                    // Ensure you're updating the correct index in the array
                                    ...prevData[0],
                                    placement: e.target.value, // Correctly update qualification
                                  },
                                }))
                              } // Update placement state
                            />
                            &nbsp; No &nbsp;
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* {activeStep === steps.length - 1 && (
          <div className="col-lg-12 mt-3">
            <div className="card p-2 pb-0">
              <div className="form-group">
                <div className="row">
                  <h4 className="mt-2 mb-4">Step 3: EMI Schedule</h4>

         
                  <div className="col-lg-12 mb-3">
                    <div className="floating-label">
                      <input
                        className="form-control"
                        type="number"
                        min="1"
                        value={addData[0]?.student_emi || ''}
                        onChange={handleEmiCountChange}
                      />
                      <label className="filled">Number of EMIs</label>
                    </div>
                  </div>

             
                  <div className="col-lg-6">
                    {datelist.map((date, index) => (
                      <div className="floating-label mb-3" key={index}>
                        <input
                          className="form-control"
                          type="date"
                          value={date}
                          onChange={(e) => handleemi_datechange(e, index)}
                        />
                        <label className="filled">EMI Date {index + 1}</label>
                      </div>
                    ))}
                  </div>


           
                  <div className="col-lg-6">
                    {addData[0]?.emilist?.slice(0, addData[0]?.student_emi).map((emi, index) => (
                      <div className="floating-label mb-3" key={index}>
                        <input
                          className="form-control"
                          type="number"
                          min="0"
                          step="0.01"
                          value={isNaN(emi) ? "" : emi}
                          onChange={(e) => handleEmiAmountChange(e, index)}
                        />
                        <label className="filled">EMI Amount {index + 1} (₹)</label>
                      </div>
                    ))}
                  </div>

        
                  <div className="col-lg-12 mt-3">
                    <div className="alert alert-info">
                      Total Fees: ₹{addData[0]?.fees || 0} |
                      Entered: ₹{(addData[0]?.emilist?.reduce((sum, amount) => sum + amount, 0) || 0).toFixed(2)} |
                      Remaining: ₹{(addData[0]?.fees - (addData[0]?.emilist?.reduce((sum, amount) => sum + amount, 0) || 0)).toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )} */}

        {activeStep === 2 && (
          <div className="col-lg-12 mt-3">
            <div className="card p-2 pb-0">
              <div className="form-group">
                <div className="row">
                  <h4 className="mt-2 mb-4">Step 3: EMI Schedule</h4>{" "}
                  <div className="col-lg-6">
                    {/* {datelist.map((date, index) => (
                      <div className="floating-label mb-3" key={index}>
                        <input
                          className="form-control"
                          type="date"
                          value={date}
                          onChange={(e) => handleemi_datechange(e, index)}
                        />
                        <label className="filled">EMI Date {index + 1}</label>
                      </div>
                    ))} */}
                    {/* {datelist.map((date, index) => (
                      <div className="floating-label mb-3" key={index}>
                        <input
                          className="form-control"
                          type="date"
                          value={formatDateForInput(date)} // Use the formatting function
                          onChange={(e) => handleemi_datechange(e, index)}
                        />
                        <label className="filled">EMI Date {index + 1}</label>
                      </div>
                    ))} */}

                    {datelist.map((date, index) => (
                      <div className="floating-label mb-3" key={index}>
                        <input
                          className="form-control"
                          type="date"
                          value={formatDateForInput(date)}
                          onChange={(e) => {
                            const newDates = [...datelist];
                            newDates[index] = e.target.value;
                            setdatelist(newDates);

                            // Update the main data structure
                            setAddData((prev) => [
                              {
                                ...prev[0],
                                datelist: newDates.map((d) =>
                                  d.includes("T")
                                    ? d
                                    : new Date(d).toISOString()
                                ),
                              },
                            ]);
                          }}
                          required
                        />
                        <label className="filled">EMI Date {index + 1}</label>
                      </div>
                    ))}
                  </div>
                  {/* EMI Amounts Column */}
                  <div className="col-lg-6">
                    {addData[0]?.emilist?.map(
                      (
                        emi,
                        index // Use `emilist` state directly
                      ) => (
                        <div className="floating-label mb-3" key={index}>
                          <input
                            className="form-control"
                            type="number"
                            min="0" // Prevent negative values
                            step="0.01" // Allow decimals
                            value={isNaN(emi) ? "" : emi}
                            onChange={(e) => handleemi_amountchange(e, index)}
                          />
                          <label className="filled">
                            EMI Amount {index + 1} (₹)
                          </label>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div style={{ marginTop: "20px" }}>
          {activeStep === steps.length - 1 ? (
            <div>
              <div className="container">
                <div className="row" style={{ marginTop: "-60px" }}>
                  <div className="col-lg-3">
                    <div className="card carddetails p-2">
                      <div>
                        <img
                          src={imagePreviewuploade}
                          alt="Uploaded or Captured"
                          width="100%"
                          height="200"
                          className="object-fit-cover mb-2"
                        />
                      </div>
                      <div className="text-center text-white">
                        <h6 className="profile-details bg-secondary">
                          <div className="row text-center">
                            <div className="col-lg-1">
                              <i class="fa-solid fa-user "></i>
                            </div>
                            <div className="col-lg-10 text-center">
                              <b>{addData[0]?.student_name_lead || ""}</b>
                            </div>
                          </div>
                        </h6>
                        <h6 className="profile-details bg-secondary">
                          <div className="row text-center">
                            <div className="col-lg-1">
                              <i class="fa-solid fa-phone"></i>
                            </div>
                            <div className="col-lg-10 text-center">
                              <b>{addData[0]?.mobile_no_lead || ""}</b>
                            </div>
                          </div>
                        </h6>
                        <h6 className="profile-details bg-secondary">
                          <div className="row text-center">
                            <div className="col-lg-1">
                              <i class="fa-solid fa-id-card"></i>
                            </div>
                            <div className="col-lg-10 text-center">
                              <b> {addData[0].register_no || ""}</b>
                            </div>
                          </div>
                        </h6>
                        <h6 className="profile-details bg-secondary">
                          <div className="row text-center">
                            <div className="col-lg-1">
                              <i class="fa-solid fa-book"></i>
                            </div>
                            <div className="col-lg-10 text-center">
                              <b>{addData[0]?.Prefered_course_lead || ""}</b>
                            </div>
                          </div>
                        </h6>
                      </div>
                    </div>

                    <div className="card carddetails p-1 mt-3">
                      <div className="row details-datas">
                        <div
                          className="col-lg-6 mt-1"
                          style={{ paddingLeft: "30px" }}
                        >
                          <b>EMI date</b>
                        </div>
                        <div className="col-lg-6 mt-1">
                          <b>EMI Amount</b>
                        </div>
                      </div>

                      {addData[0]?.datelist?.map((dateString, index) => {
                        const date = new Date(dateString);
                        const emiAmount = addData[0]?.emilist?.[index];

                        return (
                          <div className="row details-datas" key={index}>
                            <div
                              className="col-lg-6 mt-1"
                              style={{ paddingLeft: "20px" }}
                            >
                              <p>{date.toLocaleDateString()}</p>
                            </div>
                            <div className="col-lg-6">
                              <b>
                                {emiAmount
                                  ? `₹${emiAmount.toLocaleString("en-IN")}`
                                  : "N/A"}
                              </b>
                            </div>
                          </div>
                        );
                      }) || "No dates available"}
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="card cardborder">
                      <div className="lightblued p-2">
                        <div className="row p-1">
                          <div className="col-lg-5">
                            <strong>Branch </strong>
                          </div>
                          <div className="col-lg-7 ">
                            <div className="">
                              <label className="form-label bg-transparent border-0 text-secondary">
                                <b></b>
                              </label>
                              <select
                                className="form-label bg-transparent border-0 text-secondary"
                                disabled
                                value={addData[0]?.branch_lead || ""}
                                onChange={(e) => {
                                  const updatedData = [...addData]; // Copy the array
                                  updatedData[0] = {
                                    ...updatedData[0],
                                    branch_lead: e.target.value,
                                  }; // Update the first object
                                  setAddData(updatedData); // Set the new array to state
                                }}
                                required
                                style={{
                                  appearance: "none",
                                  WebkitAppearance: "none",
                                  MozAppearance: "none",
                                  background: "none",
                                  border: "none",
                                }}
                              >
                                {branch.map((item, index) => (
                                  <option key={index} value={item._id}>
                                    {item.branch_name}
                                  </option>
                                ))}
                              </select>

                              <label
                                className={addData.branch_lead ? "filled" : ""}
                              ></label>
                            </div>
                          </div>
                        </div>
                        <div className="row p-1">
                          <div className="col-lg-5">
                            <strong>Roll No </strong>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {addData[0]?.roll_no}
                          </div>
                        </div>
                        <div className="row p-1">
                          <div className="col-lg-5">
                            <strong>Father Name </strong>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {addData[0]?.father_name || ""}
                          </div>
                        </div>
                        <div className="row mt-1 p-1">
                          <div className="col-lg-5">
                            <strong>Qualification</strong>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {addData[0]?.qualification || ""}
                          </div>
                        </div>

                        <div className="row p-1">
                          <div className="col-lg-5">
                            <strong>Date of Birth</strong>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {formatDatefitching(
                              addData[0]?.date_of_birth || ""
                            )}
                          </div>
                        </div>
                        <div className="row p-1">
                          <div className="col-lg-5">
                            <strong>Email</strong>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {addData[0]?.email_lead || ""}
                          </div>
                        </div>
                        <div className="row p-1">
                          <div className="col-lg-5">
                            <strong>Current Address</strong>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {addData[0]?.current_address || ""}
                          </div>
                        </div>
                        <div className="row p-1">
                          <div className="col-lg-5">
                            <strong>Permanent Address</strong>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {addData[0]?.permanent_address || ""}
                          </div>
                        </div>
                        <div className="row mt-1 p-1">
                          <div className="col-lg-5">
                            <strong>Purpose Enquiry</strong>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {addData[0]?.student_type}
                          </div>
                        </div>
                        <div className="row p-1">
                          <div className="col-lg-5">
                            <strong>Source Type</strong>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {addData[0]?.Source_type_lead || ""}
                          </div>
                        </div>
                        <div className="row p-1">
                          <div className="col-lg-5">
                            <strong>Batch Timing </strong>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {addData[0]?.batch_timings}
                          </div>
                        </div>
                        <div className="row p-1">
                          <div className="col-lg-5">
                            <strong>Placement </strong>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {addData[0]?.placement || ""}
                          </div>
                        </div>
                        <div className="row p-1">
                          <div className="col-lg-5">
                            <strong>Trainer</strong>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {/* {addData.trainer} */}
                            <div className="" style={{ marginLeft: "-12px" }}>
                              <select
                                className="form-control bg-transparent border-0 text-secondary"
                                disabled
                                value={addData[0]?.trainer || ""} // Ensure it starts with an empty string if not set
                                onChange={(e) =>
                                  setAddData({
                                    ...addData,
                                    trainer: e.target.value,
                                  })
                                }
                              >
                                {/* Ensure value is empty for disabled option */}
                                {stafftId.map((data, index) => (
                                  <option key={index} value={data.empid}>
                                    {data.name} - {data.empid}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row p-1">
                          <div className="col-lg-5">
                            <strong>Admission Date</strong>
                          </div>
                          <div className="col-lg-7 text-secondary">
                            {formatDatefitching(addData[0]?.admission_date)}
                          </div>
                        </div>
                        <div className="row p-1">
                          <div className="col-lg-5">
                            <strong>Enquiry Date </strong>
                          </div>
                          <div className="col-lg-7 text-secondary">
                            {formatDatefitching(addData[0]?.Enquiry_date_lead)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="card carddetails p-1">
                      <div className="row p-1">
                        <div className="col-lg-12 text-danger">
                          <b>ID Proof</b>
                        </div>
                      </div>
                    </div>
                    <div className="card carddetails details-data_overall p-1">
                      <div>
                        <img
                          src={imagePreview} // Use imageFile, not image
                          alt="Uploaded or Captured"
                          width="100%"
                          height="200vh"
                          className="object-fit-full"
                        />
                      </div>
                    </div>
                    <div className="col-lg-12 col-sm-12 col-md-12 mt-3">
                      <div className="card cardborder ">
                        {/* <b className="text-danger p-1">Topics Covered</b> */}
                      </div>
                      <div className="card cardborder p-1 Completed-profile ">
                        <div className="row details-datas ">
                          <div className="col-lg-6 mt-1">
                            <b> Fees</b>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {/* {addData[0]?.fees} */}
                            {filteredData[0]?.fees}
                          </div>
                        </div>
                        <div className="row mt-2 details-datas">
                          <div className="col-lg-6 mt-1">
                            <b>Discount</b>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {/* {addData[0]?.discount} */}
                            {filteredData[0]?.discount}
                          </div>
                        </div>
                        <div className="row mt-2 details-datas">
                          <div className="col-lg-6 mt-1">
                            <b>Payment Type</b>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {addData[0]?.payment_type || ""}
                          </div>
                        </div>
                        <div className="row mt-2 details-datas">
                          <div className="col-lg-6 mt-1">
                            <b>Duration</b>
                          </div>
                          <div className="col-lg-6 text-secondary">
                            {/* {addData[0]?.duraction} */}
                            {filteredData[0]?.duration}
                          </div>
                        </div>
                      </div>

                      <div className="row p-3 ">
                        <div className="text-center ">
                          <input
                            type="checkbox"
                            id="agree"
                            click={isCheck}
                            onClick={handleClickCheckBox}
                            required
                          />
                          <label htmlFor="agree " className="mx-2">
                            I Agree to all conditions
                          </label>
                        </div>

                        <div className="col-lg-4 text-center d-flex justify-content-end">
                          <button
                            className="Cancelbut "
                            variant="secondary"
                            onClick={handlecancel}
                          >
                            Cancel
                          </button>
                        </div>
                        <div className="col-lg-4 d-flex ">
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: "blue",
                              color: "white",
                            }} // Inline style for background color
                            disabled={activeStep === 0}
                            onClick={handleBack}
                          >
                            Back
                          </Button>
                        </div>
                        <div className="col-lg-4 text-center d-flex justify-content-start">
                          <button
                            className="btn btn-success"
                            type="submit"
                            variant="primary"
                            disabled={!isCheck}
                            onClick={handlesubmit}
                          >
                            Update
                          </button>
                        </div>

                        {/* <div className="text-center mt-3"></div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              {activeStep === 0 ? (
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "gray",
                    marginRight: "10px",
                    color: "white",
                  }}
                  onClick={() => navigate("/Studyingstudents")} // Always navigates, no need for handleBack()
                >
                  Back
                </Button>
              ) : (
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "gray",
                    marginRight: "10px",
                    color: "white",
                  }}
                  onClick={handleBack}
                >
                  Back
                </Button>
              )}

              <Button variant="contained" color="primary" onClick={handleNext}>
                Next
              </Button>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default RegistrationUpdate;
